module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "qr-weibo.43835e29.png";